import { FC, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import useFetch from "src/hooks/useFetch";
import { ToastContext } from "src/context/toastContext";

import { ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import { CaseDetailUpdateProps, } from "./types";
import { LoaderContext } from "src/context/loaderContext";
import useAppealButtonFunc from "src/hooks/useAppealButtonFunc";
import { statetype } from "src/pages/dashboard/types";
import { PrecertAPIResponse } from "src/pages/precert/types";



const CaseDetailButtonUpdate: FC<CaseDetailUpdateProps> = ({ kase, showHideModalForTreatment, setDataForCancelModal }): JSX.Element => {
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const navigate = useNavigate();
  const [precertPathParameters, setPrecertPathParameters] = useState<statetype>()
  const { submiAppealForCase, apiInPorgress } = useAppealButtonFunc();





  const { mutate: fetchPrecertMutate, data: fetchPrecertResponse } =
    useFetch<PrecertAPIResponse>(APIEndpoints.FETCH_PRECERT, {}, {}, false);

  useEffect(() => {
    if (fetchPrecertResponse) {
      navigate(`/cases/${precertPathParameters && precertPathParameters.case_id}/precerts/${precertPathParameters && precertPathParameters.id}/edit`);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchPrecertResponse]);

  const navigateToPrecertForm = (caseId: number, precertId: number) => {
    const pathParams = {
      case_id: caseId,
      id: precertId
    }
    setPrecertPathParameters(pathParams)
    fetchPrecertMutate({}, pathParams)
  }
  const navigateToReviewPrecertForm = (caseId: number, precertId: number) => {
    // const pathParams = {
    //   case_id: caseId,
    //   id: precertId
    // }
    navigate(`/cases/${caseId}/precerts/${precertId}/review`);

    // setPrecertPathParameters(pathParams)
    // fetchPrecertMutate({}, pathParams)
  }




  const { loading: transferRxLoading, data: transferRxData, mutate: transferRxByCaseId } =
    useFetch(APIEndpoints.TRANSFER_RX, {}, { case_id: kase.case_id });

  useEffect(() => {
    if (transferRxData) {
      const { message } = transferRxData as unknown as { code: number; message: string; };
      showToast([message], ToastTypes.SUCCESS);
      //getCaseListing();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transferRxData]);

  useEffect(() => {
    if (transferRxLoading) setLoader();
    else hideLoader();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transferRxLoading]);


  const transferToSP = () => {
    // eslint-disable-next-line no-restricted-globals
    const res = confirm("Are you sure you want to transfer this prescription? This cannot be undone!");
    if (res)
      transferRxByCaseId()
  }




  const caseAction:any = [];
  kase.update.map((item)=>{
    if (item === 'Treated') {
      caseAction.push(
        <button
          className="btn btn-success m-1 text-white"
           onClick={() => showHideModalForTreatment({ isModalVisible: true, caseId:kase.case_id, prescriptionId: kase.prescription_id,buttonFor:"DateOfTreatment" })}
        >
          <i className="far fa-hospital"></i> Treated
        </button>)
     }
    // if(true){
    // if (item === 'X-ferred') {
    //   caseAction.push(
    //     <button
    //       className="btn btn-success m-1"
    //       onClick={() => showHideModalForTreatment({ isModalVisible: true, caseId:kase.case_id, prescriptionId: kase.case_id,buttonFor:"DateOfTreatment" })}
    //       >
    //       <i className="bi bi-clipboard-data me-2"></i> Date of Treatment
    //     </button>)
    // }
    if (item === 'X-ferred') {
      caseAction.push(
        <button
          className="btn btn-success m-1"
           onClick={() => showHideModalForTreatment({ isModalVisible: true, caseId:kase.case_id, prescriptionId: kase.prescription_id,buttonFor:"DateOfTreatment" })}
    >
          <i className="fas fa-prescription"></i> X-ferred
        </button>)
    }
    
    ///blue karna ha

    }
  )
  
  return (
    <>
      {caseAction}
    </>
  );
};

export default CaseDetailButtonUpdate;
